import React from "react";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/InfoOutlined";

function InfoToolTip({ theme, title, placement = "top", zIndex = 0 }) {
  return (
    <Tooltip title={title} arrow placement={placement}>
      <InfoIcon
        sx={{
          fontSize: "15px",
          marginLeft: "5px",
          color: theme.palette.viewIcon.main,
          alignSelf: "center",
          zIndex: zIndex,
        }}
      />
    </Tooltip>
  );
}

export default InfoToolTip;
